"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _mapMarker = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/map-marker"));

var _phone = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/phone"));

var _uiKit = require("@dbi-tools/ui-kit");

var _useStyles = require("../../hooks/useStyles");

var _themeOptions = require("../../helpers/theme-options");

var _useMedia = require("../../hooks/use-media");

var _const = require("../../const");

var _useStoreLocatorClosest = require("./hooks/use-store-locator-closest");

var _helpers = require("../../helpers");

var _lazyLoadImage = require("../lazy-load-image");

var _linkButtons = _interopRequireDefault(require("../link-buttons"));

var _storeLocator = require("./store-locator.styled");

var _const2 = require("./const");

var _style = _interopRequireDefault(require("./style"));

var _storeLocatorModal = _interopRequireDefault(require("./store-locator-modal"));

var _helpers2 = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var StoreLocatorUi = function StoreLocatorUi(props) {
  var _props$theme = props.theme,
      currentTheme = _props$theme === void 0 ? _const2.StoreLocatorThemeVariants.WHITE : _props$theme,
      headline1 = props.headline1,
      headline2 = props.headline2,
      removeTopPadding = props.removeTopPadding,
      removeBottomPadding = props.removeBottomPadding,
      storeLocatorLayoutType = props.storeLocatorLayoutType,
      changeLocationLink = props.changeLocationLink,
      changeLocationLinkText = props.changeLocationLinkText,
      makeAnAppointmentLink = props.makeAnAppointmentLink,
      makeAnAppointmentLinkText = props.makeAnAppointmentLinkText,
      _props$buttons = props.buttons,
      buttons = _props$buttons === void 0 ? [] : _props$buttons,
      isInEditor = props.isInEditor;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpenModal = _useState2[0],
      setIsOpenModal = _useState2[1];

  var _themeStrategy$curren = _themeOptions.themeStrategy[currentTheme],
      headline1Color = _themeStrategy$curren.headline1Color,
      headline2Color = _themeStrategy$curren.headline2Color,
      type = _themeStrategy$curren.type,
      size = _themeStrategy$curren.size;
  var isDarkTheme = type === _themeOptions.ThemeType.DARK;
  var isAltTheme = size === _themeOptions.ThemeSize.HALF;
  var isMobile = (0, _useMedia.useMedia)(_const.Breakpoints.MOBILE);
  var btnColor = (0, _helpers.getMainTextColorByTheme)(isDarkTheme);
  var imageViewColor = currentTheme === _const2.StoreLocatorThemeVariants.IMAGE_DARK ? 'gray800' : btnColor;
  var paddingSize = isMobile ? _const.MOBILE_PADDING_SIZE : _const.DEFAULT_PADDING_SIZE;
  var bottomIndent = removeBottomPadding ? 0 : paddingSize;
  var topIndent = removeTopPadding ? 0 : paddingSize;
  var containerIndent = [topIndent, 0, bottomIndent];
  var styles = (0, _useStyles.useStyles)('a', _style.default);
  var isImageLayout = storeLocatorLayoutType === 'image';
  var isImageTheme = currentTheme === 'image-light' || currentTheme === 'image-dark';
  var theme = {
    $theme: currentTheme,
    $styles: styles,
    $isAltTheme: isAltTheme,
    $isImageLayout: isImageLayout,
    $btnColor: btnColor
  };
  var backgroundImage = currentTheme === 'image-light' ? _const2.STORE_BG_LIGHT : _const2.STORE_BG;

  var _useStoreLocatorClose = (0, _useStoreLocatorClosest.useStoreLocatorClosest)(isInEditor),
      closestLocation = _useStoreLocatorClose.closestLocation,
      locationAllowed = _useStoreLocatorClose.locationAllowed,
      disableButton = _useStoreLocatorClose.disableButton;

  if (!closestLocation && !isInEditor) {
    return /*#__PURE__*/_react.default.createElement(_uiKit.LoadingBlock, {
      fullWidth: true,
      height: isImageLayout ? 330 : 250
    });
  }

  var address1 = (closestLocation === null || closestLocation === void 0 ? void 0 : closestLocation.location.address1) || '';
  var address2 = (closestLocation === null || closestLocation === void 0 ? void 0 : closestLocation.location.address2) || '';
  var state = (closestLocation === null || closestLocation === void 0 ? void 0 : closestLocation.location.state) || '';
  var postalCode = (closestLocation === null || closestLocation === void 0 ? void 0 : closestLocation.location.postalCode) || '';
  var phone = (closestLocation === null || closestLocation === void 0 ? void 0 : closestLocation.phone) || '';
  var storeId = (closestLocation === null || closestLocation === void 0 ? void 0 : closestLocation.storeId) || '0000';
  var storeImage = _const2.AEM_URL + "/content/dam/aem-integration/stores/Store_".concat(Number(storeId), ".jpg");

  var basicInfo = function basicInfo(centeredOnSize, color) {
    return locationAllowed && !isInEditor ? /*#__PURE__*/_react.default.createElement(_uiKit.Box, null, /*#__PURE__*/_react.default.createElement(_storeLocator.Headline3Styled, null, _const2.StoreLocatorClosestText.BLOCK_LABEL), /*#__PURE__*/_react.default.createElement(_storeLocator.ContactSectionStyled, {
      mt: 5,
      centeredOnSize: centeredOnSize
    }, /*#__PURE__*/_react.default.createElement(_storeLocator.ContactSectionIconStyled, null, /*#__PURE__*/_react.default.createElement(_mapMarker.default, {
      measure: 16,
      color: color
    })), /*#__PURE__*/_react.default.createElement(_storeLocator.ContactSectionContentStyled, null, "".concat(address2 ? "".concat(address1, ", ").concat(address2) : address1, ", ").concat(state ? state : '', " ").concat(postalCode))), /*#__PURE__*/_react.default.createElement(_storeLocator.ContactSectionStyled, {
      mt: 8,
      centeredOnSize: centeredOnSize
    }, /*#__PURE__*/_react.default.createElement(_storeLocator.ContactSectionIconStyled, null, /*#__PURE__*/_react.default.createElement(_phone.default, {
      measure: 16,
      color: color
    })), /*#__PURE__*/_react.default.createElement(_storeLocator.ContactSectionContentStyled, null, /*#__PURE__*/_react.default.createElement("a", {
      href: "tel:".concat(phone)
    }, (0, _helpers2.maskedString)(phone, '(###) ###-####'))))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      measure: {
        xs: 'md',
        md: 'lg'
      },
      fontWeight: "bold",
      m: [0]
    }, _const2.StoreLocatorClosestText.DENIED_TITLE), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      measure: {
        xs: 'md',
        md: 'lg'
      },
      fontWeight: "light",
      m: [5, 0, 0, 0]
    }, _const2.StoreLocatorClosestText.DENIED_SUBTITLE));
  };

  var imageView = function imageView() {
    return /*#__PURE__*/_react.default.createElement(_uiKit.Box, null, /*#__PURE__*/_react.default.createElement(_storeLocator.ImageViewRowStyled, null, /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
      lg: 5,
      noGutter: true
    }, /*#__PURE__*/_react.default.createElement(_storeLocator.ImageWrap, {
      isFullOnSize: "table"
    }, /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
      src: disableButton ? _const2.DEFAULT_STORE_IMAGE : storeImage,
      placeholderSrc: _const2.DEFAULT_STORE_IMAGE,
      alt: "store image"
    }))), /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
      lg: 7,
      noGutter: true
    }, /*#__PURE__*/_react.default.createElement(_storeLocator.ImageViewContentStyled, null, /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
      color: imageViewColor,
      mb: 25
    }, !!headline2 && /*#__PURE__*/_react.default.createElement(_storeLocator.Headline2ImageStyled, {
      color: imageViewColor
    }, headline2), basicInfo('tablet', imageViewColor), changeLocationLink && /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      as: "a",
      href: changeLocationLink,
      variant: "underlined",
      color: imageViewColor,
      mt: isMobile ? 15 : 20
    }, changeLocationLinkText)), /*#__PURE__*/_react.default.createElement(_uiKit.Row, null, /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      fullWidth: true,
      color: imageViewColor,
      variant: "outlined",
      onClick: function onClick() {
        return setIsOpenModal(true);
      },
      pl: 15,
      pr: 15,
      disabled: disableButton
    }, _const2.StoreLocatorClosestText.BLOCK_DETAILS)), makeAnAppointmentLink && /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      fullWidth: true,
      as: "a",
      href: makeAnAppointmentLink,
      color: imageViewColor,
      variant: "outlined",
      mt: isMobile && 15,
      pl: 15,
      pr: 15
    }, makeAnAppointmentLinkText)))))));
  };

  var textView = function textView() {
    return /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
      align: isMobile ? 'center' : 'left'
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
      md: 4
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Box, null, !!headline1 && /*#__PURE__*/_react.default.createElement(_storeLocator.Headline1Styled, {
      color: headline1Color
    }, headline1), !!headline2 && /*#__PURE__*/_react.default.createElement(_storeLocator.Headline2Styled, {
      color: headline2Color
    }, headline2))), /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
      md: 8
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
      lg: 7,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
      color: btnColor
    }, basicInfo('mobile', btnColor), changeLocationLink && /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      as: "a",
      href: changeLocationLink,
      variant: "underlined",
      color: btnColor,
      mt: 15
    }, changeLocationLinkText))), /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
      lg: 5,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Row, null, /*#__PURE__*/_react.default.createElement(_uiKit.Col, null, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      fullWidth: true,
      color: btnColor,
      variant: "outlined",
      onClick: function onClick() {
        return setIsOpenModal(true);
      },
      mt: isMobile && 30,
      pl: 15,
      pr: 15,
      disabled: disableButton
    }, _const2.StoreLocatorClosestText.BLOCK_DETAILS)), makeAnAppointmentLink && /*#__PURE__*/_react.default.createElement(_uiKit.Col, null, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      fullWidth: true,
      as: "a",
      href: makeAnAppointmentLink,
      color: btnColor,
      variant: "outlined",
      mt: 15,
      pl: 15,
      pr: 15
    }, makeAnAppointmentLinkText))))))));
  };

  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_storeLocator.StyledBox, {
    p: containerIndent,
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_STORE_LOCATOR
  }, isImageTheme && /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
    src: backgroundImage,
    alt: "closest store background",
    fit: "cover"
  }), /*#__PURE__*/_react.default.createElement(_storeLocator.ContainerStyled, null, isImageLayout ? imageView() : textView()), !!buttons.length && /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    buttons: buttons,
    color: isImageLayout ? 'gray800' : btnColor,
    mt: 30,
    alignCenter: true
  })), /*#__PURE__*/_react.default.createElement(_storeLocator.ModalStyled, {
    isOpen: isOpenModal,
    onClose: function onClose() {
      return setIsOpenModal(false);
    },
    measure: "lg"
  }, /*#__PURE__*/_react.default.createElement(_storeLocator.ModalHeaderStyled, null, _const2.StoreLocatorClosestText.BLOCK_LABEL), /*#__PURE__*/_react.default.createElement(_storeLocator.ModalBodyStyled, null, /*#__PURE__*/_react.default.createElement(_storeLocatorModal.default, _objectSpread({
    closestLocation: closestLocation
  }, props)))));
};

var _default = StoreLocatorUi;
exports.default = _default;